import { ComponentEnum } from '../enums'
const pages = [
  {
    componentId: ComponentEnum.ShippingOptions,
    title: 'Opciones del Envío',
    isSucced: false,
    isCurrent: true,
    isVisible: true,
    component: 'ShippingOptions'
  },
  {
    componentId: ComponentEnum.Incoterm,
    title: 'Incoterm Preferido',
    isSucced: false,
    isCurrent: false,
    isVisible: true,
    component: 'Incoterm'
  },
  {
    componentId: ComponentEnum.ShippingFeatures,
    title: 'Características del Envío',
    isSucced: false,
    isCurrent: false,
    isVisible: true,
    component: 'ShippingFeatures'
  },
  {
    componentId: ComponentEnum.RouteCharacteristics,
    title: 'Características del Trayecto',
    isSucced: false,
    isCurrent: false,
    isVisible: true,
    component: 'RouteCharacteristics'
  },
  {
    componentId: ComponentEnum.ComponentSelection,
    title: 'Selección de Componentes',
    isSucced: false,
    isCurrent: false,
    isVisible: true,
    component: 'ComponentSelection'
  },
  {
    componentId: ComponentEnum.WarehouseLogistics,
    title: 'Logística de Almacén',
    isSucced: false,
    isCurrent: false,
    isVisible: false
  },
  {
    componentId: ComponentEnum.ShippingLogistics,
    title: 'Logística de Envío',
    isSucced: false,
    isCurrent: false,
    isVisible: false,
    component: 'ShippingLogistics',
    parentId: ComponentEnum.WarehouseLogistics
  },
  {
    componentId: ComponentEnum.ReceptionLogistics,
    title: 'Logística de Recepción',
    isSucced: false,
    isCurrent: false,
    isVisible: false,
    component: 'ReceptionLogistics',
    parentId: ComponentEnum.WarehouseLogistics
  },
  {
    componentId: ComponentEnum.InsuranceAndExtras,
    title: 'Seguros y Extras',
    isSucced: false,
    isCurrent: false,
    isVisible: false,
    component: 'InsuranceAndExtras',
    parentId: ComponentEnum.WarehouseLogistics
  },

  {
    componentId: ComponentEnum.InlandTransportationParent,
    title: 'Transporte Interior',
    isSucced: false,
    isCurrent: false,
    isVisible: false
  },
  {
    componentId: ComponentEnum.InlandTransportation,
    title: 'Transporte Interior',
    isSucced: false,
    isCurrent: false,
    isVisible: false,
    component: 'InlandTransportation',
    parentId: ComponentEnum.InlandTransportationParent
  },
  {
    componentId: ComponentEnum.InlandTransportationImport,
    title: 'Transporte Interior',
    isSucced: false,
    isCurrent: false,
    isVisible: false,
    component: 'InlandTransportationImport',
    parentId: ComponentEnum.InlandTransportationParent
  },
  {
    componentId: ComponentEnum.ProcessingAndFees,
    title: 'Tramitación y Tasas',
    isSucced: false,
    isCurrent: false,
    isVisible: false
  },
  {
    componentId: ComponentEnum.AdministrationFees,
    title: 'Gastos de Pre-Embarque',
    isSucced: false,
    isCurrent: false,
    isVisible: false,
    component: 'AdministrationFees',
    parentId: ComponentEnum.ProcessingAndFees
  },
  {
    componentId: ComponentEnum.ProceduresAndPermits,
    title: 'Trámites y Permisos',
    isSucced: false,
    isCurrent: false,
    isVisible: false,
    component: 'ProceduresAndPermits',
    parentId: ComponentEnum.ProcessingAndFees
  },
  {
    componentId: ComponentEnum.CustomClearanceImport,
    title: 'Tramitación Aduanal',
    isSucced: false,
    isCurrent: false,
    isVisible: false,
    component: 'CustomClearanceImport',
    parentId: ComponentEnum.ProcessingAndFees
  },
  {
    componentId: ComponentEnum.TaxesAndFees,
    title: 'Tasas e Impuestos',
    isSucced: false,
    isCurrent: false,
    isVisible: false,
    component: 'TaxesAndFees',
    parentId: ComponentEnum.ProcessingAndFees
  },
  {
    componentId: ComponentEnum.InternationalFreight,
    title: 'Flete Internacional',
    isSucced: false,
    isCurrent: false,
    isVisible: false
  },
  {
    componentId: ComponentEnum.TerminalManagement,
    title: 'Gestión Portuaria',
    isSucced: false,
    isCurrent: false,
    isVisible: false,
    component: 'TerminalManagement',
    parentId: ComponentEnum.InternationalFreight
  },
  {
    componentId: ComponentEnum.TerminalManagementImport,
    title: 'Gestión Portuaria',
    isSucced: false,
    isCurrent: false,
    isVisible: false,
    component: 'TerminalManagementImport',
    parentId: ComponentEnum.InternationalFreight
  },
  {
    componentId: ComponentEnum.AirportManagement,
    title: 'Gestión Aeroportuaria',
    isSucced: false,
    isCurrent: false,
    isVisible: false,
    component: 'AirportManagement',
    parentId: ComponentEnum.InternationalFreight
  },

  {
    componentId: ComponentEnum.AirportManagementImport,
    title: 'Gestión Aeroportuaria',
    isSucced: false,
    isCurrent: false,
    isVisible: false,
    component: 'AirportManagementImport',
    parentId: ComponentEnum.InternationalFreight
  },

  {
    componentId: ComponentEnum.InternationalTransport,
    title: 'Transporte Internacional',
    isSucced: false,
    isCurrent: false,
    isVisible: false,
    component: 'InternationalTransport',
    parentId: ComponentEnum.InternationalFreight
  },
  {
    componentId: ComponentEnum.Results,
    title: 'Resultados',
    isSucced: false,
    isCurrent: false,
    isVisible: true,
    component: 'Results'
  }

]
const wizardStore = {
  state: {
    pages: pages,
    page: 0
  },
  mutations: {
    nextPage (state) {
      let currentPage = state.pages[state.page]
      if (state.page + 1 === state.pages.length) return currentPage

      currentPage.isSucced = true
      currentPage.isCurrent = false
      while (state.page < state.pages.length) {
        state.page += 1
        currentPage = state.pages[state.page]
        if (currentPage.isVisible) {
          currentPage.isCurrent = true
          if (currentPage.component) {
            break
          }
        }
      }
      return currentPage
    },
    backPage (state) {
      let currentPage = state.pages[state.page]
      if (state.page === 0) {
        return currentPage
      }
      currentPage.isCurrent = false
      while (state.page > 0) {
        state.page -= 1
        currentPage = state.pages[state.page]
        if (currentPage.isVisible) {
          currentPage.isSucced = false
          currentPage.isCurrent = false
          if (currentPage.component) {
            currentPage.isCurrent = true
            break
          }
        }
      }
      return currentPage
    },
    resetWizardStore (state, isIncoterm) {
      let component = null
      if (isIncoterm) {
        component = ComponentEnum.Incoterm
        state.page = 1
      } else {
        component = ComponentEnum.ShippingOptions
        state.page = 0
      }
      state.pages.forEach((page) => {
        page.children = null
        if (page.componentId === component) {
          page.isCurrent = true
          page.isSucced = false
        } else {
          page.isCurrent = false
          page.isSucced = false
        }
        if (page.componentId > ComponentEnum.ComponentSelection &&
                    page.componentId < ComponentEnum.Results) {
          page.isVisible = false
        }
      })
    },

    visibleComponents (state, components) {
      state.pages.forEach(page => {
        const currentComponent = components.find(x => x.componentId === page.componentId)
        if (currentComponent) {
          page.isVisible = currentComponent.status
        }
      })
    }
  },
  actions: {
    resetCosts ({ commit }) {
      commit('resetWizardStore')
      commit('resetComponentSelectionStore')
      commit('resetTransportChainCostStore')
    }
  },
  getters: {
    currentPage (state) {
      return state.pages[state.page]
    },
    visiblePages (state) {
      return state.pages.filter(x => x.isVisible)
    },
    nestedPages (state) {
      let currentPage = null
      const activePages = []
      let pageNumber = 1

      state.pages.filter(x => x.isVisible).forEach((item) => {
        item.pageNumber = pageNumber
        pageNumber += 1
        if (!item.parentId) {
          if (currentPage) activePages.push(currentPage)
          if (item.children) item.children = []
          currentPage = item
        } else {
          if (!currentPage.children) currentPage.children = []
          currentPage.children.push(item)
        }
      })
      activePages.push(currentPage)
      return activePages
    }
  }
}
export default wizardStore
